import {Component, Input} from '@angular/core';
import {CATEGORY_TYPES, ContentHeaderBlock} from '@shared/services/hygraph/hygraph.models';

@Component({
  selector: 'app-hygraph-header',
  templateUrl: './hygraph-header.component.html',
  styleUrls: ['./hygraph-header.component.scss']
})
export class HygraphHeaderComponent {
  @Input() title: string;
  @Input() header: ContentHeaderBlock;
  @Input() date: Date;

  getCategoryTags() {
    return this.header.categoryTags.filter(
      tag => ([CATEGORY_TYPES.THEME, CATEGORY_TYPES.TECHNOLOGY] as string[]).includes(tag.categoryType)
    ).map(tag => tag.displayName).join(', ');
  }

  getAuthors() {
    return this.header.authors?.map(a => a.name).join(', ');
  }
}
